import { Box, Grid, keyframes, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../Component/Carousel/Carousel';
import Slider from '../Component/Slider/Slider';
import { BannerSkeleton, Shimmer } from '../Component/Skeletones/Skeletones';
import { ApiGetAllCategory, ApiGetAllProducts, ApiGetBanners, ApiGetNewArrivals, ApiGetShopProfile } from '../Core/Apicall';
import { toast } from 'react-toastify';
import { Color } from '../Models/Color';
import { Gender } from '../Models/Gender';
import { Product } from '../Models/Products';
import { Category } from '../Models/Category';


// const categories = Array.from({ length: 10 }, (_, index) => ({
//   id: index + 1,
//   name: `Category ${index + 1}`,
//   products: `${(Math.random() * 5 + 1).toFixed(1)}k+ Products`,
//   image: "#", // Replace with your image path
// }));



// export interface Category {
//   categoryId: number;
//   categoryName: string;
//   categoryIcon: string;
//   slug: string;
//   level: number;
//   is_active: boolean;
//   sort_order: number;
//   type: string;
//   created_at: string;
//   updated_at: string;
//   created_by: number;
//   updated_by: number;
// }






// export interface Color {
//   colorId: number;
//   name: string;
//   hex_code: string;
//   is_active: boolean;
//   created_at: string;
//   updated_at: string;
// }





// export interface Review {
//   [key: string]: any;
// }

function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const slides = [
    { className: "bg-danger" },
    { className: "bg-info" },
    { className: "bg-success" },
  ];
  const slides2 = [
    { className: "bg-danger" },
    { className: "bg-info" },
    { className: "bg-success" },
    { className: "bg-danger" },
    { className: "bg-info" },
    { className: "bg-success" },
    { className: "bg-danger" },
    { className: "bg-info" },
    { className: "bg-success" },
  ];
  const [TrendeingProducts, setTrendingPeoducts] = useState<Product[]>([])
  const [discountedProducts, setDiscoundedProducts] = useState<Product[]>([])
  const [newArrivals, setNewArrivals] = useState<Product[]>([])
  const [categories, setCategories] = useState<any>([])
  const [brands, setBrands] = useState<any>([])
  const [banners, setBanners] = useState<any>([])


  const getNewArrivals = async () => {
    try {
      const data = `?limit=10&offset=0&type=newArrival`
      const res = await ApiGetAllProducts(data)
      if (res?.success) {
        setNewArrivals(res?.data)
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }
  const getTrandingProducts = async () => {
    try {
      const data = `?limit=10&offset=0&type=newArrival`
      const res = await ApiGetAllProducts(data)
      if (res?.success) {
        setTrendingPeoducts(res?.data)
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }

  const getDiscounedProduct = async () => {
    try {
      const data = `?limit=10&offset=0&discount=30`
      const res = await ApiGetAllProducts(data)
      if (res?.success) {
        setDiscoundedProducts(res?.data)
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }

   const getShopProfile = async () => {
      try {
        const data = ""
        const res = await ApiGetShopProfile(data)
        if (res.success || res.status) {
          setBrands(res?.data?.data)
          // dispatch(setVenderDetails(res?.data[0]))
        }
      } catch (error: any) {
        console.log("Error", error)
        toast.error(error?.message || "Something went wrong");
      }
    }

  useEffect(() => {
    getNewArrivals()
    getTrandingProducts()
    getDiscounedProduct()
    GetBanners()
    getCategories()
    getShopProfile()
  }, [])

  const GetBanners = async () => {
    try {
      const res: any = await ApiGetBanners()
      if (res?.success) {
        setBanners(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "something wen wrong")
    }
  }

  const getCategories = async () => {
    try {
      const data = `?type=ALL`
      const res = await ApiGetAllCategory(data)
      if (res?.success) {
        const final_data  = res?.data?.filter((item:Category)=>item?.parent == null) 
        setCategories(final_data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    }
  }

  return (
    <Box className="w-100 pb-3 h-content overflowX-hidden">

      {/* <div id="carouselExampleIndicators" className="carousel slide hv-75 border" data-bs-ride="carousel" >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          />

          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          />

          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          />
        </div>

        <div className="carousel-inner h-100">
          <div className="carousel-item active bg-info h-100">
            <img className="d-block  w-100" src="..." alt="First slide" />
          </div>
          <div className="carousel-item bg-danger h-100">
            <img className="d-block w-100" src="..." alt="Second slide" />
          </div>
          <div className="carousel-item bg-success h-100">
            <img className="d-block w-100" src="..." alt="Third slide" />
          </div>
        </div>
        <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only"></span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only"></span>
        </a>
      </div> */}
      <Box className='px-3 border-10 w-100  overflow-hidden'>
        <Box className='w-100 border-10 overflow-hidden my-3' sx={{ height: { xs: "300px", md: "800px" } }}>
          {banners ? (
            <Carousel
              cardHeight={"100%"}
              breakpoints={{
                xs: 1,
                sm: 1,
                md: 1,
                lg: 1,
              }}
              autoPlay={true}
              slides={banners}
            />
          ) : (
            <>
              <Shimmer
                height={{
                  xs: "600px",
                  md: "600px",
                  lg: "600px",
                }}
                width={{
                  xs: "100%",
                  md: "100%",
                  lg: "100%",
                }}
                borderRadius={5}
              />
            </>
          )}

        </Box>
      </Box>

      <Box className='mt-5 px-2 mt-5 mb-5 mx-1 mx-md-5'>
        <Box className="d-flex align-items-center justify-content-between w-100 mb-3">
          <Typography variant='h4' className='text-white fw-bold'>Trending</Typography>
          <Link className='text-white fs-14' to={`/products/new-arrivals`}>View all</Link>
        </Box>
        {/* <Carousel cardHeight={isMobile ? "200px" : isTablet ? '300px' : "400px"} breakpoints={{
          xs: 2.5,
          sm: 2.5,
          md: 3.5,
          lg: 4.5,
        }} visibleCount={4} slides={slides2} gap={20} /> */}
        {TrendeingProducts?.length > 0 ? (
          <Slider slides={TrendeingProducts} />
        ) : (
          <Grid
            container
            spacing={2.5}
            sx={{ overflow: 'hidden', flexWrap: 'nowrap' }}
          >
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid size={'auto'}>
                <Shimmer
                  height={{
                    xs: "250px",
                    md: "250px",
                    lg: "300px",
                  }}
                  width={{
                    xs: "250px",
                    md: "250px",
                    lg: "300px",
                  }}
                  borderRadius={5}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>


      <Box className='third-section bg-grey mt-5 mb-5 mx-2 mx-md-5'>
        <Typography className='text-center fs-42 mx-2 mx-md-0 text-white fw-bold'>Browse by Categories</Typography>
        <Grid container className='mt-5' rowSpacing={5}>
          {categories?.length > 0 ? categories.map((item: Category) => (
            <Grid key={item?.categoryId} size={{ xs: 4, md: 3, lg: 2 }} className='d-flex flex-column align-items-center justify-content-center'>
             <Link className='text-decoration-none' to={`/products/product-category/${item.slug}`}> <Box component={'img'} src={item?.categoryIcon} sx={{ height: { xs: "100px", md: '120px' }, width: { xs: "100px", md: '120px' } }} className='border-50 border mb-2'></Box>
              <Typography className='text-white fw-bold  fs-16' gutterBottom>{item?.categoryName}</Typography></Link>
              {/* <Typography className='text-grey fs-12'>{item?.products}</Typography> */}
            </Grid>
          ))
            :
            (
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                <Grid size={{ xs: 4, md: 3, lg: 2 }} className='d-flex flex-column align-items-center justify-content-center'>
                  <Shimmer
                    height={{
                      xs: "100px", md: '120px'
                    }}
                    width={{
                      xs: "100px", md: '120px'
                    }}
                    borderRadius={'50%'}
                  />
                </Grid>
              ))
            )
          }

        </Grid>
      </Box>


      <Box className='mt-5 px-2 px-md-5 pt-4 bg-green pb-3'>
        <Box className="d-flex align-items-center justify-content-between w-100 mb-4">
          <Typography className='text-white fs-36 fw-bold'>New Arrivals</Typography>
          <Link className='text-white fs-14' to={`/products/new-arrivals`}>View all</Link>
        </Box>

        {/* <Carousel breakpoints={{
          xs: 2.5,
          sm: 2.5,
          md: 3.5,
          lg: 4.5,
        }} cardHeight={isMobile ? "200px" : isTablet ? '300px' : "400px"} visibleCount={4} slides={slides2} gap={20} /> */}
        {/* <Slider slides={slides2} /> */}
        {newArrivals?.length > 0 ? (
          <Slider slides={newArrivals} />
        ) : (
          <Grid
            container
            spacing={2.5}
            sx={{ overflow: 'hidden', flexWrap: 'nowrap' }}

          >
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid size={'auto'}>
                <Shimmer
                  height={{
                    xs: "250px",
                    md: "250px",
                    lg: "300px",
                  }}
                  width={{
                    xs: "250px",
                    md: "250px",
                    lg: "300px",
                  }}
                  borderRadius={5}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>


      <Box className='my-5 px-2 px-md-5'>
        <Typography className='text-white fs-36  text-center fw-bold mb-4'>Browse by Brands</Typography>
        <Grid container spacing={{ xs: 2, lg: 1 }} className='justify-content-center align-items-center'>
          {brands?.length > 0 ? (
            brands?.map((item:any)=>(
              <Grid size={{ xs: 4, lg: 'auto' }} sx={{ height: { xs: "120px", sm: "150px", lg: "170px" }, width: { md: '170px' }}} className='border-10 border-main' > 
             <Link to={`/store/${item?.teamId}`}><img src={item?.logo_url} height={'100%'} width={'100%'} alt="" /></Link>
              </Grid>
            ))
          ) : (
            [1, 2, 3, 4, 5, 6, 7].map((item) => (
              <Grid size={{ xs: 4, lg: 'auto' }} sx={{ height: { xs: "120px", sm: "150px", lg: "200px" }, width: { md: '200px' } }} className='border-10' >
                <Shimmer
                  height={'100%'}
                  width={'100%'}
                />
              </Grid>

            ))
          )}
        </Grid>
      </Box>

      <Box className='mt-5 px-2 px-md-5'>
        <Box className="d-flex align-items-center justify-content-between w-100 mb-3">
          <Typography className='text-white fs-32 fw-bold'>Min. 30% Off</Typography>
          {/* <Link className='text-white fs-14' to={`/products/new-arrivals`}>View all</Link> */}
          <Link className='text-white fs-14' to={`/products/discounted-products`}>View all</Link>
        </Box>
        {/* <Carousel breakpoints={{
          xs: 2.5,
          sm: 2.5,
          md: 3.5,
          lg: 4.5,
        }} cardHeight={isMobile ? "200px" : isTablet ? '300px' : "400px"} visibleCount={4} slides={slides2} gap={20} /> */}
        {/* <Slider slides={slides2} /> */}
        {discountedProducts?.length > 0 ? (
          <Slider slides={discountedProducts} />
        ) : (
          <Grid
            container
            spacing={2.5}
            sx={{ overflow: 'hidden', flexWrap: 'nowrap' }}

          >
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid size={'auto'}>
                <Shimmer
                  height={{
                    xs: "250px",
                    md: "250px",
                    lg: "300px",
                  }}
                  width={{
                    xs: "250px",
                    md: "250px",
                    lg: "300px",
                  }}
                  borderRadius={5}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

    </Box>
  );
}

export default Home;
